var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EditBrand',{attrs:{"brandId":_vm.brandId,"slugAlreadyExists":_vm.slugAlreadyExists},on:{"editDetail":_vm.editCategory,"cancelEdit":_vm.cancelEdit,"updateSlugAlreadyExists":_vm.updateSlugAlreadyExists}}),_c('ProductList',{attrs:{"brandId":_vm.brandId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }